import React, { useCallback, useEffect, useState } from "react";

import * as R from "ramda";

export const AuthenticationContext = React.createContext(null);

export const AuthenticationProvider = ({
  children,
  currentError,
  setAuthenticationError,
  history,
}) => {
  const [loggedIn, setLoggedIn] = useState(false);
  const [loginVisible, setLoginVisible] = useState(false);
  const [authCanceled, setAuthCanceled] = useState(false);

  const onLoginComplete = useCallback(
    () => {
      if (currentError) {
        currentError.resolve();
      }

      setAuthenticationError(null);
    },
    [currentError]
  );

  const cancelAuth = useCallback(loginState => {
    setAuthCanceled(loginState);
    setAuthenticationError(null);
  }, []);

  // history is undefined during server-side rendering
  const path = R.path(["location", "pathname"], history);

  // Clear the authenticationError when navigating to a different page. This
  // other page may cause a new authentication error to be displayed but
  // switching pages should clear the modal.
  useEffect(
    () => {
      setAuthenticationError(null);
      setAuthCanceled(false);
    },
    [path]
  );

  return (
    <AuthenticationContext.Provider
      value={{
        loggedIn,
        setLoggedIn,
        loginVisible,
        setLoginVisible,
        currentError,
        setAuthenticationError,
        onLoginComplete,
        authCanceled,
        setAuthCanceled,
        cancelAuth,
      }}
    >
      {children}
    </AuthenticationContext.Provider>
  );
};



// WEBPACK FOOTER //
// ./src/banking/AuthenticationContext.js